import React from 'react'
import type { ToastEmitter } from './types'
import { globalToastEmitter } from './helpers/events'

export const ToastContext = React.createContext<{ toastEmitter: ToastEmitter }>({
  toastEmitter: globalToastEmitter,
})
